import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
// import App from "./App";
import "./index.css";
import { API_ENDPOINTS } from "@/src/config/api.js";
import { ThemeProvider } from "./components/theme-provider";
import FeaturedCarousel from "./components/FeaturedCarousel";
import RecentlyPostedTracks from './components/RecentlyPostedTracks';
import RecentThreads from './components/RecentThreads';
import PromoTracks from './components/PromoTracks';
import Interviews from './components/Interviews';
import PopularTracks from './components/PopularTracks';
import Quote from './components/Quote';
import Question from './components/Question';
import HomeImage from "./components/HomeImage";
import MobileMenu from "./components/MobileMenu";
import MobileMenuButton from './components/MobileMenuButton';
import MixOfTheWeek from './components/MixOfTheWeek';
import NewsletterSignup from './components/NewsletterSignup';
import StoreCarousel from './components/StoreCarousel';
import NowAvailable from './components/NowAvailable';
// import Header from './components/Header';

// const App = () => {

//   return (
//     <>test
//     </>
//   )
// }

// ReactDOM.createRoot(document.getElementById("root")).render(
//   <React.StrictMode>
//     <ThemeProvider>
//       <App />
//     </ThemeProvider>
//   </React.StrictMode>
// );

ReactDOM.createRoot(document.getElementById('root-home-image')).render(
  <HomeImage />,
)

// Create a wrapper component to manage mobile menu state
const AppWrapper = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [checkTotd, setCheckTotd] = useState(true);

  // TOTD
  useEffect(() => {
    // Track of the Day Notification Logic
    let interval;
    const fetchTotd = () => {
      fetch(API_ENDPOINTS.tracks.mostRecent)
        .then(res => res.json())
        .then(data => {
          const latestTrackId = data && data[0] && data[0].id || 0;
          const userTotd = localStorage.getItem('user_view_totd');
          const showNotificationDot = !userTotd || userTotd !== latestTrackId;
          const dot = document.getElementById('totd-notification-dot');
          if (dot) {
            if (showNotificationDot) {
              setCheckTotd(false);
              dot.style.display = 'block';
            } else {
              dot.style.display = 'none';
            }
          }
          // When the user clicks TRACKS, update localStorage and hide the dot
          const tracksLink = document.getElementById('topnav-totd');
          if (tracksLink) {
            tracksLink.addEventListener('click', () => {
              localStorage.setItem('user_view_totd', latestTrackId);
              setCheckTotd(false);
              if (window.gtag) {
                window.gtag('event', 'top_nav', {
                  eventLabel: 'Tracks',
                  itemId: 'tracks',
                });
              }
              if (dot) dot.style.display = 'none';
            });
          }
          // Stop fetching if notification is shown
          if (showNotificationDot && interval) {
            clearInterval(interval);
          }
        })
        .catch(error => {
          console.error('Error fetching TOTD data:', error);
        });
    };
    fetchTotd();
    interval = setInterval(() => {
      if (checkTotd) fetchTotd();
    }, 240000); // 4 minutes
    return () => clearInterval(interval);
  }, [checkTotd]);

  useEffect(() => {
    // Interviews Notification Logic
    let interval;
    const fetchInterview = () => {
      const cacheBuster = Date.now();
      fetch(API_ENDPOINTS.interviews.json(cacheBuster))
        .then(res => res.json())
        .then(data => {
          // Find the highest interview_id
          let highestId = null;
          for (const key in data) {
            const id = parseInt(data[key].interview_id, 10);
            if (!highestId || id > highestId) highestId = id;
          }
          const userInterview = localStorage.getItem('user_view_interview');
          const showNotificationDot = !userInterview || userInterview !== String(highestId);
          const dot = document.getElementById('interview-notification-dot');
          if (dot) {
            if (showNotificationDot) {
              dot.style.display = 'block';
            } else {
              dot.style.display = 'none';
            }
          }
          // When the user clicks INTERVIEWS, update localStorage and hide the dot
          const interviewsLink = document.getElementById('topnav-interview');
          if (interviewsLink) {
            interviewsLink.addEventListener('click', () => {
              localStorage.setItem('user_view_interview', String(highestId));
              if (window.gtag) {
                window.gtag('event', 'top_nav', {
                  eventLabel: 'Interviews',
                  itemId: 'interviews',
                });
              }
              if (dot) dot.style.display = 'none';
            });
          }
        })
        .catch(error => {
          console.error('Error fetching Interviews data:', error);
        });
    };
    fetchInterview();
    interval = setInterval(fetchInterview, 240000); // 4 minutes
    return () => clearInterval(interval);
  }, []);


  // Function to update mobile menu state
  window.setMobileMenuOpen = (isOpen) => {
    setIsMobileMenuOpen(isOpen);
  };

  return (
    <>
      <MobileMenu
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
      />
    </>
  );
};

ReactDOM.createRoot(document.getElementById('root-home-featured')).render(
  <FeaturedCarousel />,
)

ReactDOM.createRoot(document.getElementById('root-home-recent-tracks')).render(
  <RecentlyPostedTracks />,
)

ReactDOM.createRoot(document.getElementById('root-home-recent-threads')).render(
  <RecentThreads />,
)

ReactDOM.createRoot(document.getElementById('root-home-promo-tracks')).render(
  <PromoTracks />,
)

ReactDOM.createRoot(document.getElementById('root-home-interviews')).render(
  <Interviews />,
)

ReactDOM.createRoot(document.getElementById('root-home-popular-tracks')).render(
  <PopularTracks />,
)
ReactDOM.createRoot(document.getElementById('root-home-quote')).render(
  <Quote />,
)

ReactDOM.createRoot(document.getElementById('root-home-question')).render(
  <Question />,
)
ReactDOM.createRoot(document.getElementById('root-home-mix-of-the-week')).render(
  <MixOfTheWeek />,
)

ReactDOM.createRoot(document.getElementById('root-home-mobile-button')).render(
  <MobileMenuButton />,
)
ReactDOM.createRoot(document.getElementById('root-home-newsletter')).render(
  <NewsletterSignup />,
)

ReactDOM.createRoot(document.getElementById('root-home-store')).render(
  <StoreCarousel />,
)

ReactDOM.createRoot(document.getElementById('root-home-now-available')).render(
  <NowAvailable />,
)

// ReactDOM.createRoot(document.getElementById('root-home-header')).render(
//   <Header />,
// )

// Create a new root for the mobile menu
ReactDOM.createRoot(document.getElementById('root-mobile-menu')).render(
  <AppWrapper />,
)


// Track of the Day Notification Logic
// fetch('https://dreamchimney.com/api/tracks/most_recent')
//   .then(res => res.json())
//   .then(data => {
//     const latestTrackId = data && data[0] && data[0].id || 0;
//     const userTotd = localStorage.getItem('user_view_totd');
//     const dot = document.getElementById('totd-notification-dot');
//     if (dot) {
//       if (!userTotd || userTotd !== latestTrackId) {
//         dot.style.display = 'block';
//       } else {
//         dot.style.display = 'none';
//       }
//     }
//     // When the user clicks TRACKS, update localStorage and hide the dot
//     const trackLink = document.getElementById('topnav-totd');
//     if (trackLink) {
//       trackLink.addEventListener('click', () => {
//         localStorage.setItem('user_view_totd', latestTrackId);
//         if (window.gtag) {
//           window.gtag('event', 'top_nav', {
//             eventLabel: 'Tracks',
//             itemId: 'tracks',
//           });
//         }
//         if (dot) dot.style.display = 'none';
//       });
//     }
//   })
//   .catch(error => {
//     console.error('Error fetching TOTD data:', error);
//   });


// MOTW Notification Logic
fetch(API_ENDPOINTS.motw.latest)
  .then(res => res.json())
  .then(data => {
    const latestMotw = data['motw-series-number'];
    const userMotw = localStorage.getItem('user_view_motw');
    const dot = document.getElementById('motw-notification-dot');
    if (dot) {
      if (!userMotw || userMotw !== latestMotw) {
        dot.style.display = 'block';
      } else {
        dot.style.display = 'none';
      }
    }
    // When the user clicks MIXES, update localStorage and hide the dot
    const mixesLink = document.getElementById('topnav-motw');
    if (mixesLink) {
      mixesLink.addEventListener('click', () => {
        localStorage.setItem('user_view_motw', latestMotw);
        if (window.gtag) {
          window.gtag('event', 'top_nav', {
            eventLabel: 'Mixes',
            itemId: 'mixes',
          });
        }
        if (dot) dot.style.display = 'none';
      });
    }
  })
  .catch(error => {
    console.error('Error fetching MOTW data:', error);
  });
